import { useEffect, useState } from 'react';
import { Link } from 'react-router-dom';
import { initGA4 } from '../../lib/analytics';

const STORAGE_KEY = 'professya_cookie_consent';

export function CookieConsentBanner() {
  const [show, setShow] = useState(false);

  useEffect(() => {
    const stored = localStorage.getItem(STORAGE_KEY);
    if (!stored) {
      const t = setTimeout(() => setShow(true), 800);
      return () => clearTimeout(t);
    } else if (stored === 'accepted' || stored === 'all') {
      const id = import.meta.env.VITE_GA4_MEASUREMENT_ID;
      if (id) initGA4(id);
    }
  }, []);

  function acceptEssential() {
    localStorage.setItem(STORAGE_KEY, 'accepted');
    setShow(false);
  }

  function acceptAll() {
    localStorage.setItem(STORAGE_KEY, 'all');
    setShow(false);
    const id = import.meta.env.VITE_GA4_MEASUREMENT_ID;
    if (id) initGA4(id);
  }

  if (!show) return null;

  return (
    <div
      role="dialog"
      aria-label="Preferências de cookies"
      style={{
        position: 'fixed',
        bottom: '1.25rem',
        left: '1rem',
        right: '1rem',
        maxWidth: '440px',
        margin: '0 auto',
        zIndex: 9998,
        backgroundColor: 'var(--bg-elevated)',
        border: '1px solid var(--line-medium)',
        borderRadius: 'var(--radius-lg)',
        padding: '1.25rem 1.5rem',
        animation: 'slide-up 300ms cubic-bezier(0.2, 0.8, 0.2, 1) both',
      }}
    >
      <p style={{ fontFamily: 'var(--font-body)', fontSize: 'var(--text-13)', color: 'var(--text-secondary)', lineHeight: 1.6, margin: '0 0 1rem' }}>
        Usamos cookies essenciais e, com sua autorização, cookies analíticos para melhorar a experiência.{' '}
        <Link to="/privacidade" style={{ color: 'var(--petrol)', textDecoration: 'underline' }}>
          Política de privacidade
        </Link>
      </p>
      <div style={{ display: 'flex', gap: '0.5rem' }}>
        <button className="btn btn-primary btn-sm" onClick={acceptAll}>
          Aceitar todos
        </button>
        <button className="btn btn-secondary btn-sm" onClick={acceptEssential}>
          Só necessários
        </button>
      </div>
    </div>
  );
}
